import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ListItemText } from '@mui/material';
import { LanguageTranslationKeys } from 'i18n/languages/en';
import store from 'store';

import type { MenuItemWithText } from '@common/constants/CampusMenuTypes';

import { StyledNavBarBadge, StyledNavBarIcon, StyledNavBarWrap } from './styled';

interface PropsType extends MenuItemWithText<LanguageTranslationKeys> {
	onClick?: (href: string) => void;
}

function NavBarItem({ icon, text, href, services, onClick, badge }: PropsType) {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	if (!services.includes(store.services.current.id)) return;

	const handleNavigate = () => {
		onClick ? onClick(href) : navigate(href);
	};

	const isSelected = href === '/' ? pathname === '/' : pathname.startsWith(href);
	const badgeContent = typeof badge === 'boolean' ? null : badge;

	return (
		<StyledNavBarWrap onClick={handleNavigate} isSelected={isSelected}>
			<StyledNavBarIcon>{icon}</StyledNavBarIcon>
			<StyledNavBarBadge invisible={!badge} badgeContent={badgeContent}>
				<ListItemText>{t(text)}</ListItemText>
			</StyledNavBarBadge>
		</StyledNavBarWrap>
	);
}

export default observer(NavBarItem);
